import { Trustpilot } from "modules/storyblok/adapters/Trustpilot";
import { TrustpilotExcellent } from "./Trustpilot";

export interface TrustpilotExtendedProps {
  trustpilotVariant: "option-1" | "option-2";
}

export const TrustpilotExtended = ({ trustpilotVariant }: TrustpilotExtendedProps) =>
  trustpilotVariant === "option-1" ? <Trustpilot /> : <TrustpilotExcellent />;
